import { Box, styled, Typography } from "@mui/material";
import { navData } from "../../constants/data";

const Component = styled(Box)(({ theme }) => ({
  display: "flex",
  margin: "55px 130px 0px 130px",
  justifyContent: "space-between",
  // overflow:'overlay',
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    margin: "55px 0px 0px 0px",
  },
}));

const Container = styled(Box)`
  padding: 12px 8px;
  text-align: center;
`;
const Text = styled(Typography)`
  font-size: 14px;
  font-family: inherit;
  font-weight: 600;
`;

const NavBar = () => {
  return (
    <Box
      style={{
        background: "#fff",
      }}
    >
      <Component>
        {navData.map((data) => (
          <Container>
            <img src={data.url} alt="nav" style={{ width: 64 }} />
            <Text>{data.text}</Text>
          </Container>
        ))}
      </Component>
    </Box>
  );
};
export default NavBar;
